const audienceTrackingValueMap = {
  PUBLIC: 'public',
  PRIVATE: 'my_contacts',
};
export const mapAudienceTrackingValue = (id: 'PUBLIC' | 'PRIVATE') =>
  audienceTrackingValueMap[id];
